import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Image } from 'Components/frameworks/image/Image';
type Props = {
  className?: string;
  onClose?: () => void;
  resort: Readonly<{
    image?: string;
    name: string;
  }>;
};
const DIMENSIONS = {
  h: 408,
  w: 734,
};
export const AlternativeDateSuggestionImmersive = ({ className, onClose, resort }: Props) => {
  const trackClick = useTracking({
    actionGA: 'checkPricesKO',
    categoryGA: 'search',
  });
  return (
    <div className={classnames('w-full', className)}>
      <div className="overflow-hidden rounded-12">
        <Image
          altMsg={resort.name}
          dimensions={DIMENSIONS}
          hasLazyLoading={false}
          imageUrl={resort.image}
        />
      </div>
      {!!onClose && (
        <button
          className="mt-20 flex items-center gap-5 font-sans text-16 text-sienna"
          onClick={() => {
            onClose && onClose();
            trackClick({
              labelGA: 'backResortPage',
            });
          }}
          type="button"
        >
          {t('booking.counterProposalPopIn.doNotCheckPriceLabel')}
          <Icon name={ICONS.ARROW_RIGHT} />
        </button>
      )}
    </div>
  );
};
